import React from 'react';
import AlpacaBackendExample from '@/components/trading/AlpacaBackendExample';

const TradingBackendTest: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-4xl mx-auto space-y-4">
        <h1 className="text-2xl font-bold">Alpaca Backend Test</h1>
        <p className="text-gray-600">Use this page to verify JWT-authenticated trading operations.</p>
        <AlpacaBackendExample />
      </div>
    </div>
  );
};

export default TradingBackendTest;
